export default __webpack_public_path__ + "media/carousel/paste-12c59eec.png";